import { Component, effect, inject, input, signal } from "@angular/core";

import { SafeHtmlPipe } from "../../../../core/pipes";
import { FilesApiService } from "../../../services";

@Component({
  selector: "adaa-picture",
  imports: [SafeHtmlPipe],
  templateUrl: "./picture.html",
  styleUrl: "./picture.scss",
})
export class PictureComponent {
  pictureId = input<number>();
  picture = input<string>("/assets/images/profile_placeholder.png");
  style = input<string>("object-fit: cover; border-radius: 10px");
  width = input<string>("70px");
  height = input<string>("auto");

  isSVG: boolean = false;
  contentString = signal<string>("");

  private readonly _fileService = inject(FilesApiService);

  constructor() {
    effect(() => {
      const id = this.pictureId();
      if (!id) return;

      this._downloadFile(id);
    });
  }

  private _downloadFile(id: number) {
    this._fileService.download(id).subscribe({
      next: async (blob) => {
        // Detect SVG
        const declaredSvg = (blob.type ?? "").includes("svg");
        if (declaredSvg) {
          this.isSVG = true;
          const svgMarkup = await blob.text();
          this.contentString.set(svgMarkup);
          return;
        }

        // Fallback: peek into content when MIME is generic (e.g., application/octet-stream)
        try {
          const text = await blob.text();
          if (text.trim().startsWith("<svg")) {
            this.isSVG = true;
            this.contentString.set(text);
            return;
          }
        } catch {}

        // unknown: use object URL
        this.isSVG = false;
        const objectUrl = window.URL.createObjectURL(blob);
        this.contentString.set(objectUrl);
      },
    });
  }
}
